import useDashboardStats from "../pages/Dashboard";
import { Grid, Paper, Typography, Box } from "@mui/material";
import { People, Category, Groups } from "@mui/icons-material";
import PageLayout from "./admin/PageLayout";

const StatCard = ({ title, value, icon, color = "primary.main" }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "divider",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      transition: "box-shadow 0.2s ease, transform 0.2s ease",
      "&:hover": {
        boxShadow: "0px 8px 24px rgba(94, 53, 177, 0.12)",
        transform: "translateY(-2px)",
      },
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: 2,
        bgcolor: `${color}20`,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
      }}
    >
      {icon}
    </Box>
    <Typography variant="body2" color="text.secondary" fontWeight={500}>
      {title}
    </Typography>
    <Typography variant="h4" fontWeight={700} color="primary.main" sx={{ mt: 0.5 }}>
      {value}
    </Typography>
  </Paper>
);

const Dashboard = () => {
  const { usersCount, categoriesCount, expenseSharingGroupCount } = useDashboardStats();

  return (
    <PageLayout
      title="Dashboard"
      subtitle="Overview of your Treasure admin data."
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Total Users"
            value={usersCount}
            icon={<People sx={{ fontSize: 28 }} />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Total Categories"
            value={categoriesCount}
            icon={<Category sx={{ fontSize: 28 }} />}
            color="secondary.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Expense sharing groups"
            value={expenseSharingGroupCount}
            icon={<Groups sx={{ fontSize: 28 }} />}
            color="success.main"
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
};

export default Dashboard;
